import * as React from 'react';

import SuperCritical, { SuperCriticalComponent } from 'lib/supercritical';

import { DateRangeSelectorView } from 'portcall/daterangeselector/view';
import { IssuesShortSummary,IssueCountBadge } from 'portcall/issues/view';

import {VesselPortCalls, PortCallViewModel, PortCallsViewModel, ItineraryViewModel} from './model'; 

export const VesselPortCallsView = SuperCritical(({ model: m } : { model : VesselPortCalls }) =>
      <div className="page-body">
        <div className="main-page">
            <VesselPortCallsHeaderView model={m} />
            <VesselPortCallsDetailView model={m} />
        </div>
    </div>  
);

let VesselPortCallsHeaderView = SuperCritical(({ model } : { model : VesselPortCalls })=> {
    let m = model.Model();
    return <div className="port-calls-header">
            <div className="vessel-name">
                <div className="vessel-name-text">
                    <span>{m.Vessel() && m.Vessel()!.Name()}</span>
                </div>
            </div>
            <div className="filter-criteria">
                <DateRangeSelectorView model={model.DateRangeSelector} />
            </div>
        </div>;
    }
)

let VesselPortCallsDetailView = SuperCritical(({model: m} : {model : VesselPortCalls}) =>
    <div className="page-table">
        <table className="table">
            <TableBody model={PortCallsViewModel(m.Model().PortCalls)} />
        </table>
    </div>
)

let TableBody = SuperCritical(({ model: m } : { model : PortCallsViewModel }) =>
    <tbody>
        {m.PortCalls().map(port =>
            [
            <PortCallHeader model={port} key={port.PortCall.Id()} />
            ].concat(port.Itineraries().map(i => 
                <PortCallDetailView model={i} portcall={port}  key={i.Itinerary.Id()} />
            )).concat(
                <PortCallSpacer />
            )
        )}
    </tbody>
);

let PortCallHeader = SuperCritical(({model : m } : { model : PortCallViewModel}) =>
    <tr className="port-header" onClick={m.NavigateToPortCall}>
        <td>{m.MinDate()}</td>
        <td>{m.PortName()}</td>
        <td className="pc-text-label-color">Voyage</td>
        <td>{m.VoyageNumber()}</td>
        <td></td>
        <td></td>
        <td></td>
    </tr>)

let PortCallDetailView = SuperCritical(({model : m, portcall : pc } : { model : ItineraryViewModel, portcall : PortCallViewModel}) =>
    <tr onClick={pc.NavigateToPortCall}>
        <td>{m.HasIssues() ? <IssueCountBadge issues={m.Issues} /> : ''}</td>
        <td>{m.LocationName()}</td>
        <td className="pc-text-label-color">Arrive</td>
        <td>{m.Arrival}</td>
        <td className="pc-text-label-color">{m.Itinerary.Id() == (pc.LastReservation() && pc.LastReservation()!.Id()) ? 'Depart' : 'Shift'}</td>
        <td>{m.Departure}</td>
        <td>{m.HasIssues() ? <IssuesShortSummary issues={m.Issues} />  : m.ReservationStatus}</td>
    </tr>)

let PortCallSpacer = SuperCritical(() =>
    <tr className="portcall-spacer">
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>)




// WEBPACK FOOTER //
// ./apps/portcall/vesselportcalls/view.tsx